import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { AppRoutes } from './routes/AppRoutes';

// アプリケーションのメインコンポーネント
const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Layout>
                <AppRoutes />
            </Layout>
        </BrowserRouter>
    );
};

export default App;